<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="start" style="margin-top:20px;"><a id="epigraph">“The rest of my speech” (he explained to his men)</a></p><a id="epigraph">
<p class="ind">“You shall hear when I’ve leisure to speak it,</p>
<p class="noind">But the Snark is at hand, let me tell you again!</p>
<p class="ind">’Tis your glorious duty to seek it!</p>
<p class="noind" style="margin-top:20px;">“To seek it with thimbles, to seek it with care;</p>
<p class="ind">To pursue it with forks and hope;</p>
<p class="noind">To threaten its life with a railway share;</p>
<p class="ind">To charm it with smiles and soap!</p>
<p class="noind" style="margin-top:20px;">“For the Snark’s a peculiar creature, that won’t</p>
<p class="ind">Be caught in a commonplace way. </p>
<p class="noind">Do all that you know, and try all that you don’t:</p>
<p class="ind">Not a chance must be wasted to-day!”</p>
<p class="epi" style="margin-top:20px;">—Lewis Carroll</p>
<p class="epi2"><i>The Hunting of the Snark</i></p>
<p class="epi2">An Agony in Eight Fits (1876)</p>
<p class="epi2">Fit the Fourth</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5start.vue?3aa8ca70